"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Style_1 = require("./Style");
function adj(style) {
    const { textAlign = "center" } = style;
    style.textAlign = textAlign;
    return style;
}
let defaultStyle;
class ButtonStyle extends Style_1.Style {
    constructor(style = {}) {
        super(adj(style));
        const { buttonBgColor } = style;
        this._buttonBgColor = buttonBgColor;
    }
    static get DEFAULT() {
        return defaultStyle ? defaultStyle : (defaultStyle = new ButtonStyle());
    }
    get buttonBgColor() {
        return this._buttonBgColor;
    }
    set buttonBgColor(buttonBgColor) {
        this._buttonBgColor = buttonBgColor;
        this.doChangeStyle();
    }
    clone() {
        return new ButtonStyle(this);
    }
}
exports.ButtonStyle = ButtonStyle;
